import {
  MediaPipeline,
  StreamState,
} from '@optools/services/operator-gateway/types/generated/graphql';
import { SlateCodes } from '@optools/services/operator-gateway/types/slate';

export const GAME_STATE = {
  GAME: 'Game',
  NONE: '',
  POST_GAME: 'Post-Game',
  PRE_GAME: 'Pre-Game',
  STAY_TUNED: 'Stay Tuned',
  TYFW: 'Thank You For Watching',
} as const;

export type GameState = (typeof GAME_STATE)[keyof typeof GAME_STATE];

export const determineGameStateFromValues = (
  activeSlateCode: MediaPipeline['activeSlateCode'],
  streamState: MediaPipeline['streamState'],
): GameState => determineGameState({ activeSlateCode, streamState });

export const determineGameState = (
  pipeline?: Pick<MediaPipeline, 'activeSlateCode' | 'streamState'>,
): GameState => {
  if (!pipeline) return GAME_STATE.NONE;
  const { activeSlateCode, streamState } = pipeline;

  if (streamState === StreamState.STREAM_ON) {
    return activeSlateCode && activeSlateCode === SlateCodes.PSB
      ? GAME_STATE.STAY_TUNED
      : GAME_STATE.PRE_GAME;
  }

  if (streamState === StreamState.PROGRAM_ON) {
    return GAME_STATE.GAME;
  }

  if (streamState === StreamState.PROGRAM_DONE) {
    return activeSlateCode === SlateCodes.TYFW ? GAME_STATE.TYFW : GAME_STATE.POST_GAME;
  }

  return GAME_STATE.NONE;
};
